import Icon from '../components/Icon.vue'

Icon.register({"briefcase":{"width":512,"height":512,"paths":[{"d":"M320 288H512V432C512 458.5 490.5 480 464 480H48C21.5 480 0 458.5 0 432V288H192V308C192 314.6 197.4 320 204 320H308C314.6 320 320 314.6 320 308V288zM512 176V256H0V176C0 149.5 21.5 128 48 128H128V80C128 53.5 149.5 32 176 32H336C362.5 32 384 53.5 384 80V128H464C490.5 128 512 149.5 512 176zM320 96H192V128H320V96z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/briefcase.js